import { css, Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { roundCornersShadowBorder } from "../../../../../../assets/styles/styles";
import {
  NotificationIndicatorForTemplate,
  NotificationIndicatorForTemplateProps,
} from "../../../../../atoms/NotificationIndicator";

export const iconCss = (theme: Theme) => css`
  color: ${theme.colors.primaryColor};
  font-size: 50px;
  width: 100%;
`;

export const labelCss = css`
  // https://stackoverflow.com/a/65723242/10467064
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media only screen and (max-width: 1024px) {
    font-size: 10px;
    -webkit-line-clamp: 2;
  }
`;

export const outerContainerCss = css`
  ${roundCornersShadowBorder()};
  width: 180px;
  min-width: 180px;
  height: 180px;
  display: inline-block;
  position: relative;

  @media only screen and (max-width: 1024px) {
    width: 100px;
    min-width: 100px;
    height: 100px;
  }
`;

export const innerContainerCss = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 50px;
  &:hover {
    text-decoration: none;
  }

  @media only screen and (max-width: 1024px) {
    margin-top: 15px;
  }
`;

export const ToggleStarFavourite = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;

  @media only screen and (max-width: 1024px) {
    svg {
      font-size: 25px;
    }
  }
`;

export const NotificationIndicatorFavourite = styled(
  NotificationIndicatorForTemplate
)<NotificationIndicatorForTemplateProps>`
  position: absolute;
  right: 50px;
  top: 3px;
  transform: translate(50%, -50%);
`;

export const iconContainerCss = css`
  @media only screen and (max-width: 1024px) {
    line-height: 1;
  }
`;
